const pdfsGenerateTypes = Object.freeze({
  generate_type_meeting_and_mandates_pdfs: 1,
  generate_type_mandates_and_recipients_pv_antet_pdfs: 2,
});
const pdfsGeneratePvTypes = Object.freeze({
  generate_type_include_all_participants: 1,
  generate_type_include_only_against_and_nsp: 2,
});

export { pdfsGenerateTypes, pdfsGeneratePvTypes };
